import { render, staticRenderFns } from "./RecipientPreviewExpandableTable.vue?vue&type=template&id=2f9d0123"
import script from "./RecipientPreviewExpandableTable.vue?vue&type=script&lang=js"
export * from "./RecipientPreviewExpandableTable.vue?vue&type=script&lang=js"
import style0 from "./RecipientPreviewExpandableTable.vue?vue&type=style&index=0&id=2f9d0123&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports